import { render, staticRenderFns } from "./RecipeRow.vue?vue&type=template&id=78980e11&"
import script from "./RecipeRow.vue?vue&type=script&lang=js&"
export * from "./RecipeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports